import Api from "@/services/api";
import {
  GET_ALL_ALLOWED_IPS,
  CREATE_ALLOWED_IP,
  GET_ALLOWED_IP_BY_ID,
  UPDATE_ALLOWED_IP,
  DELETE_ALLOWED_IP,
} from "@/store/_actiontypes";
import {
  SET_ALL_ALLOWED_IPS,
  SET_ALLOWED_IP_BY_ID,
} from "@/store/_mutationtypes";

import { updateLoaderTo } from "./account";

const state = {
  allAllowedIps: [],
  selectedAllowedIp: {},
};

const actions = {
  // Get all allowed IPs
  [GET_ALL_ALLOWED_IPS]({ commit }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.get("/allowed-ips")
        .then((response) => {
          let allAllowedIps = response.data;
          commit(SET_ALL_ALLOWED_IPS, allAllowedIps);
          updateLoaderTo(false);
          resolve(response);
        })
        .catch((error) => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },

  // Create a new allowed IP
  [CREATE_ALLOWED_IP]({ commit }, payload) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.post("/allowed-ips", {
        ip_address: payload.ip_address,
        title: payload.title,
        status: payload.status || "enabled",
        allowed_type: payload.allowed_type || "registration",
      })
        .then((response) => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch((error) => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },

  // Get allowed IP details by ID
  [GET_ALLOWED_IP_BY_ID]({ commit }, { id }) {
    updateLoaderTo(true);
    commit(SET_ALLOWED_IP_BY_ID, {});
    return new Promise((resolve, reject) => {
      Api.get(`/allowed-ips/${id}`)
        .then((response) => {
          let allowedIp = response.data;
          commit(SET_ALLOWED_IP_BY_ID, allowedIp);
          updateLoaderTo(false);
          resolve(response);
        })
        .catch((error) => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },

  // Update allowed IP
  [UPDATE_ALLOWED_IP]({ commit }, { id, payload }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.put(`/allowed-ips/${id}`, {
        ip_address: payload.ip_address,
        title: payload.title,
        status: payload.status || "enabled",
        allowed_type: payload.allowed_type || "registration",
      })
        .then((response) => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch((error) => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },

  // Delete allowed IP
  [DELETE_ALLOWED_IP]({ commit }, { id }) {
    updateLoaderTo(true);
    return new Promise((resolve, reject) => {
      Api.delete(`/allowed-ips/${id}`)
        .then((response) => {
          updateLoaderTo(false);
          resolve(response);
        })
        .catch((error) => {
          updateLoaderTo(false);
          reject(error);
        });
    });
  },
};

const mutations = {
  [SET_ALL_ALLOWED_IPS](state, allAllowedIps) {
    state.allAllowedIps = allAllowedIps;
  },
  [SET_ALLOWED_IP_BY_ID](state, selectedAllowedIp) {
    state.selectedAllowedIp = selectedAllowedIp;
  },
};

export const allowed_ips = {
  namespaced: true,
  state,
  actions,
  mutations,
};
